<template>
  <div class="consolidated-data">
    <Loader v-if="loading" compact />

    <div v-if="!loading" class="consolidated-panel">
      <div v-if="fetchFailed === true && userLevel == 'pecsmart'" class="chart-without-data chart-without-data--panel">
        <h1 class="error-message">{{errorMessage}}</h1>
      </div>
      <div v-else-if="fetchFailed === true && userLevel !== 'pecsmart'" class="chart-without-data chart-without-data--panel">
        <h1 class="error-message">SEM DADOS</h1>
        <h1 class="error-message">DE CONSUMO DISPONÍVEIS</h1>
      </div>

      <div v-else-if="chartWarning(siloUnloadDataset) && chartWarning(siloUnloadDatasetAccumulated)" class="chart-without-data chart-without-data--panel">
        <h1>SEM DADOS</h1>
      </div>

      <template v-else>
        <div class="chart-toolbar">
          <div class="toolbar-group toolbar-group--filters">
            <div class="date-filter-buttons">
              <button
                class="filter-btn"
                :class="{ active: activeFilter === '7days' }"
                @click="setDateFilter('7days')">
                Último 7 dias
              </button>
              <button
                class="filter-btn"
                :class="{ active: activeFilter === '15days' }"
                @click="setDateFilter('15days')">
                15 dias
              </button>
              <button
                class="filter-btn"
                :class="{ active: activeFilter === '30days' }"
                @click="setDateFilter('30days')">
                Último mês
              </button>
              <button
                class="filter-btn"
                :class="{ active: activeFilter === 'full_batch' }"
                :disabled="!batch"
                @click="setDateFilter('full_batch')"
                :title="batch && batch.date_departure ? 'Do início ao fim do lote' : 'Do início do lote até hoje'">
                Lote Completo
              </button>
              <div class="custom-date-filter">
                <input
                  type="date"
                  v-model="customStartDate"
                  class="date-input"
                  placeholder="Fecha inicio"
                />
                <input
                  type="date"
                  v-model="customEndDate"
                  class="date-input"
                  placeholder="Fecha fin"
                />
                <button
                  class="filter-btn custom-filter-btn"
                  :class="{ active: activeFilter === 'custom' }"
                  @click="setCustomDateFilter">
                  Filtrar
                </button>
              </div>
            </div>
          </div>
          <div class="toolbar-divider" aria-hidden="true"></div>
          <div class="toolbar-group toolbar-group--actions">
            <div class="export-dropdown toolbar-actions">
              <button
                type="button"
                class="button-food"
                @click="openFoodModal">
                Materia Prima
              </button>
              <button class="export-btn" @click="toggleDropdown">
                <i class="fas fa-download"></i>
                <span>Exportar</span>
                <i class="fas fa-chevron-down"></i>
              </button>
              <div class="dropdown-content" v-if="showDropdown">
                <a @click="exportToPDF">
                  <i class="fas fa-file-pdf"></i>
                  <span>PDF</span>
                </a>
                <a @click="exportToExcel">
                  <i class="fas fa-file-excel"></i>
                  <span>Excel</span>
                </a>
              </div>
            </div>
          </div>
        </div>

        <!-- Card con Tabs -->
        <div class="chart-card">
              <div class="tabs-container">
                <div class="tabs-header">
                  <button
                    class="tab-button"
                    :class="{ active: activeTab === 'consolidated' }"
                    @click="activeTab = 'consolidated'"
                  >
                    Consumo Consolidado
                  </button>
                  <button
                    v-if="batch && batch !== null && (batch.final_count > 0 || batch.initial_count > 0)"
                    class="tab-button"
                    :class="{ active: activeTab === 'perHead' }"
                    @click="activeTab = 'perHead'"
                  >
                    Consumo por Cabeça
                  </button>
                  <button
                    class="tab-button"
                    :class="{ active: activeTab === 'accumulated' }"
                    @click="activeTab = 'accumulated'"
                  >
                    Consumo Acumulado
                  </button>
                </div>

                <div class="tab-content">
                                     <!-- Tab 1: Consumo Consolidado -->
                   <div v-if="activeTab === 'consolidated'" class="tab-panel">
                      <div v-if="chartWarning(siloUnloadDataset)" class="chart-without-data">
                        <h1>SEM DADOS</h1>
                        <h1>SUFICIENTES</h1>
                      </div>
                      <div v-else>
                        <ConsolidatedConsumeChart
                          :key="componentKeyUnload"
                          :chartLabels="consolidatedConsumeLabels"
                          :chartDataValues="consolidatedConsumeValues"
                          :estimatedFlags="consolidatedConsumeEstimated"
                          :formatDateRange="formatDateRange"
                        />
                      </div>
                   </div>

                  <!-- Tab 2: Consumo por Cabeça -->
                  <div v-if="activeTab === 'perHead'" class="tab-panel">
                    <div v-if="!batch || batch === null" class="chart-without-data">
                      <h1>SEM LOTE</h1>
                      <h1>DISPONÍVEL</h1>
                    </div>
                    <div v-else-if="(batch.final_count <= 0 && batch.initial_count <= 0)" class="chart-without-data">
                      <h1>SEM DADOS</h1>
                      <h1>DE CONTAGEM</h1>
                    </div>
                    <div v-else-if="chartWarning(siloConsumePerHeadDataset)" class="chart-without-data">
                      <h1>SEM DADOS</h1>
                      <h1>SUFICIENTES</h1>
                    </div>
                      <div v-else>
                          <ConsumePerHeadChart
                            :key="componentKeyConsumePerHead"
                            :chartLabels="consumePerHeadLabels"
                            :chartDataValues="consumePerHeadValues"
                            :formatDateRange="formatDateRange"
                          />
                      </div>
                  </div>

                  <!-- Tab 3: Consumo Acumulado -->
                  <div v-if="activeTab === 'accumulated'" class="tab-panel">
                    <div v-if="chartWarning(siloUnloadDatasetAccumulated)" class="chart-without-data">
                      <h1>SEM DADOS</h1>
                      <h1>SUFICIENTES</h1>
                    </div>
                                         <div v-else >
                        <AccumulatedConsumeChart
                          :key="componentKeyAccumulated"
                          :chartLabels="accumulatedConsumeLabels"
                          :chartDataValues="accumulatedConsumeValues"
                          :formatDateRange="formatDateRange"
                        />
                      </div>
                  </div>
                </div>
              </div>
            </div>
      </template>
    </div>
  </div>
</template>

<script>
import ConsolidatedConsumeChart from "./ConsolidatedConsumeChart.vue";
import Loader from "./Loader.vue";
import ConsumePerHeadChart from "./ConsumePerHeadChart.vue";
import AccumulatedConsumeChart from "./AccumulatedConsumeChart.vue";
import { format, parseISO } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import { generateConsolidatePDF } from '../pdf/pdfConsolidated';
import { generateConsolidateExcel } from '../excel/excelConsolidated';
import { generatePerHeadPDF } from '../pdf/pdfPerHead';
import { generatePerHeadExcel } from '../excel/excelPerHead';
import { generateAccumulatedPDF } from '../pdf/pdfAccumulated';
import { generateAccumulatedExcel } from '../excel/excelAccumulated';

export default {
  name: "SmartFeed",
  props: ["sensor", "workingSensors", "startDate", "endDate", "seekNewRange", "allFoods"],
  components: {
    ConsolidatedConsumeChart,
    Loader,
    ConsumePerHeadChart,
    AccumulatedConsumeChart,
  },
  data() {
    return {
      loading: true,
      fetchFailed: false,
      isAccumulatedView: false,
      chartOffsetUnload: true,
      yAxesScaleUnload: true,
      componentKeyUnload: 0,
      componentKeyConsumePerHead: 0,
      componentKeyAccumulated: 0,
      showDropdown: false,
      activeTab: 'consolidated', // Default active tab
      startDateFilter: null,
      endDateFilter: null,
      activeFilter: '7days', // Default filter
      customStartDate: null,
      customEndDate: null,
    };
  },
  methods: {
    getAnimalCountForDate(dateStr) {
      if (!this.batch) return 0;
      const initialCount = this.batch.initial_count || 0;
      if (initialCount <= 0) return 0;

      const targetDay = this.formatToYYYYMMDD(dateStr);
      let cumulativeLosses = 0;

      // lossesBatch is already sorted by death_datetime ASC
      for (const loss of this.lossesBatch) {
        const lossDay = this.formatToYYYYMMDD(loss.death_datetime);
        if (!lossDay) continue;
        if (lossDay > targetDay) break;
        cumulativeLosses += loss.quantity || 0;
      }

      return Math.max(initialCount - cumulativeLosses, 0);
    },
    formatToYYYYMMDD(dateString) {
      if (!dateString) return '';
      try {
        // Si la fecha tiene formato ISO o incluye tiempo
        if (dateString.includes('T') || dateString.includes(' ')) {
          return format(parseISO(dateString), 'yyyy-MM-dd');
        }
        // Si ya est├í en formato YYYY-MM-DD
        return dateString;
      } catch (error) {
        console.error('Error formatting date:', error);
        return dateString;
      }
    },
    chartWarning(dataset) {
      if (dataset.length < 1) return true;
      return false;
    },
    changeUnloadChart() {
      // Toggle between accumulated and daily view
      this.isAccumulatedView = !this.isAccumulatedView;

      // Force rerender to update the chart
      this.forceRerenderUnload();
    },
    forceRerenderUnload: function() {
      this.componentKeyUnload += 1;
    },
    forceRerenderConsumePerHead: function() {
      this.componentKeyConsumePerHead += 1;
    },
    forceRerenderAccumulated: function() {
      this.componentKeyAccumulated += 1;
    },
    exportToPDF() {
      try {
        if (!this.sensorsData || !this.sensorsData.data) {
          console.error('No hay datos para exportar');
          return;
        }

        const locationInfo = {
          farmName: this.farmName,
          batchName: this.batchName.replace('- LOTE ', ''),
          barnName: this.barnName
        };

        if (this.userLevel === 'pecsmart') {
          if (this.activeTab === 'perHead') {
            if (!this.batch || (this.batch.final_count <= 0 && this.batch.initial_count <= 0)) {
              alert('No hay datos de conteo disponibles para exportar consumo por cabeza');
              return;
            }

            const initialCount = this.batch.initial_count;

            const perHeadData = this.sensorsData.data
              .filter(item => {
                const itemDate = this.formatToYYYYMMDD(item.date);
                return itemDate >= this.chartStartDate && itemDate <= this.chartEndDate;
              })
              .map(item => {
                const animalCount = this.getAnimalCountForDate(item.date) || initialCount;
                return {
                  date: item.date,
                  consume_per_head: animalCount > 0 ? item.consume / animalCount : 0,
                  food_id: item.food_id
                };
              });

            generatePerHeadPDF(
              perHeadData,
              true,
              this.workingSensors,
              this.allFoods,
              locationInfo
            );
            return;
          } else if (this.activeTab === 'accumulated') {
            const filteredData = this.sensorsData.data.filter(item => {
              const itemDate = this.formatToYYYYMMDD(item.date);
              return itemDate >= this.chartStartDate && itemDate <= this.chartEndDate;
            });

            let accumulated = 0;
            const accumulatedData = filteredData.map(item => {
              accumulated += item.consume;
              return {
                date: item.date,
                accumulated_consume: accumulated,
                food_id: item.food_id
              };
            });

            generateAccumulatedPDF(
              accumulatedData,
              true,
              this.workingSensors,
              this.allFoods,
              locationInfo
            );
            return;
          }
        }

        const filteredData = this.sensorsData.data.filter(item => {
          const itemDate = this.formatToYYYYMMDD(item.date);
          return itemDate >= this.chartStartDate && itemDate <= this.chartEndDate;
        });

        generateConsolidatePDF(
          filteredData,
          true,
          this.workingSensors,
          this.allFoods,
          locationInfo
        );
      } catch (error) {
        console.error('Error al generar PDF:', error);
      }
    },
    exportToExcel() {
      try {
        if (!this.sensorsData || !this.sensorsData.data) {
          console.error('No hay datos para exportar');
          return;
        }

        const locationInfo = {
          farmName: this.farmName,
          batchName: this.batchName.replace('- LOTE ', ''),
          barnName: this.barnName
        };

        if (this.userLevel === 'pecsmart') {
          if (this.activeTab === 'perHead') {
            if (!this.batch || (this.batch.final_count <= 0 && this.batch.initial_count <= 0)) {
              alert('No hay datos de conteo disponibles para exportar consumo por cabeza');
              return;
            }

            const initialCount = this.batch.initial_count;

            const perHeadData = this.sensorsData.data
              .filter(item => {
                const itemDate = this.formatToYYYYMMDD(item.date);
                return itemDate >= this.chartStartDate && itemDate <= this.chartEndDate;
              })
              .map(item => {
                const animalCount = this.getAnimalCountForDate(item.date) || initialCount;
                return {
                  date: item.date,
                  consume_per_head: animalCount > 0 ? item.consume / animalCount : 0,
                  food_id: item.food_id
                };
              });

            generatePerHeadExcel(
              perHeadData,
              this.workingSensors,
              this.allFoods,
              locationInfo
            );
            return;
          } else if (this.activeTab === 'accumulated') {
            const filteredData = this.sensorsData.data.filter(item => {
              const itemDate = this.formatToYYYYMMDD(item.date);
              return itemDate >= this.chartStartDate && itemDate <= this.chartEndDate;
            });

            let accumulated = 0;
            const accumulatedData = filteredData.map(item => {
              accumulated += item.consume;
              return {
                date: item.date,
                accumulated_consume: accumulated,
                food_id: item.food_id
              };
            });

            generateAccumulatedExcel(
              accumulatedData,
              this.workingSensors,
              this.allFoods,
              locationInfo
            );
            return;
          }
        }

        const filteredData = this.sensorsData.data.filter(item => {
          const itemDate = this.formatToYYYYMMDD(item.date);
          return itemDate >= this.chartStartDate && itemDate <= this.chartEndDate;
        });

        generateConsolidateExcel(
          filteredData,
          this.workingSensors,
          this.allFoods,
          locationInfo
        );
      } catch (error) {
        console.error('Error al generar Excel:', error);
      }
    },
    toggleDropdown() {
      this.showDropdown = !this.showDropdown;
    },
    openFoodModal() {
      const $ = window.jQuery || window.$
      if ($ && typeof $.fn.modal === 'function') {
        $('#foodModal').modal('show')
        return
      }
      const el = document.getElementById('foodModal')
      if (el) {
        el.classList.add('show')
        el.style.display = 'block'
        el.removeAttribute('aria-hidden')
        document.body.classList.add('modal-open')
      }
    },
    initializeDateFilters() {
      const today = new Date();
      const isBatchActive = this.batch?.date_departure == null;

      const referenceDate = isBatchActive
        ? today
        : parseISO(this.batch.date_departure);

      if (this.activeFilter === 'full_batch') {
        const accommodationDate = this.batch?.date_accomodation
          ? parseISO(this.batch.date_accomodation)
          : referenceDate;
        this.startDateFilter = format(accommodationDate, 'yyyy-MM-dd');
        this.endDateFilter = format(referenceDate, 'yyyy-MM-dd');
        return;
      }

      const filterDaysMap = {
        '7days': 7,
        '15days': 15,
        '30days': 30
      };
      
      const daysToSubtract = filterDaysMap[this.activeFilter] || 7;
      
      const startDate = new Date(referenceDate);
      startDate.setDate(referenceDate.getDate() - daysToSubtract);
      
      const accommodationDate = this.batch?.date_accomodation
        ? parseISO(this.batch.date_accomodation)
        : null;
      
      if (accommodationDate && startDate < accommodationDate) {
        startDate.setTime(accommodationDate.getTime());
      }
      
      this.startDateFilter = format(startDate, 'yyyy-MM-dd');
      this.endDateFilter = format(referenceDate, 'yyyy-MM-dd');
    },
    setDateFilter(filter) {
      this.activeFilter = filter;
      this.initializeDateFilters();
      this.forceRerenderUnload();
      this.forceRerenderConsumePerHead();
      this.forceRerenderAccumulated();
    },
    setCustomDateFilter() {
      if (!this.customStartDate || !this.customEndDate) {
        alert('Por favor selecione ambas as datas');
        return;
      }

      if (this.customStartDate > this.customEndDate) {
        alert('A data de in├¡cio n├úo pode ser maior que a data de fim');
        return;
      }

      this.activeFilter = 'custom';
      this.startDateFilter = this.customStartDate;
      this.endDateFilter = this.customEndDate;
      this.forceRerenderUnload();
      this.forceRerenderConsumePerHead();
      this.forceRerenderAccumulated();
    }
  },
  computed: {
    unloadChartDisplay() {
      return this.isAccumulatedView ? this.unloadAccData : this.unloadData;
    },
    computed_level() {
      if (this.sensorsData?.last_hour_level == null) return "Sem N├¡vel";
      return `${this.sensorsData.last_hour_level}%`;
    },
    computed_weight() {
      if (this.sensorsData?.last_hour_weight == null) return "Sem Peso";
      return `${this.sensorsData.last_hour_weight} kg`;
    },
    sensorsData() {
      try {
        return this.$store.getters.getSmartFeedConsolidatedData.find(
          (item) => item.barn === this.barn.pk
        );
      } catch (err) {
        return null;
      }
    },
    siloUnloadDataset() {
      try {
        if (this.batch.date_departure == null) {
          return this.sensorsData.data
            .filter(item => {
              const itemDate = this.formatToYYYYMMDD(item.date);
              return itemDate >= this.startDateFilter && itemDate <= this.endDateFilter;
            })
            .map((item) => {
              return {
                x: item.date,
                y: Number(item.consume).toFixed(2),
              };
            });
        } else {
          return this.sensorsData.data
          .filter(item => {
            const itemDate = this.formatToYYYYMMDD(item.date);
            return itemDate >= this.startDateFilter && itemDate <= this.endDateFilter;
          })
          .map((item) => {
            return {
              x: item.date,
              y: Number(item.consume).toFixed(2),
            };
          });
        }
      } catch (err) {
        return [];
      }
    },
    siloUnloadDatasetAccumulated() {
      try {
        let accumulated = 0;
        return this.sensorsData.data
          .filter(item => {
            const itemDate = this.formatToYYYYMMDD(item.date);
            return itemDate >= this.startDateFilter && itemDate <= this.endDateFilter;
          })
          .map((item) => {
            let y = item.consume + accumulated;
            accumulated += item.consume;
            return {
              x: item.date,
              y: Number(y).toFixed(2),
            };
          });
      } catch (err) {
        return [];
      }
    },
    siloConsumePerHeadDataset() {
      try {
        if (!this.batch || this.batch === null) {
          return [];
        }

        const initialCount = this.batch.initial_count || 0;

        if (initialCount <= 0) {
          return [];
        }

        const array = this.sensorsData.data
          .filter(item => {
            const itemDate = this.formatToYYYYMMDD(item.date);
            return itemDate >= this.startDateFilter && itemDate <= this.endDateFilter;
          })
          .map(item => {
            const animalCount = this.getAnimalCountForDate(item.date) || initialCount;
            const consumePerHead = animalCount > 0 ? item.consume / animalCount : 0;
            return {
              "x": item.date,
              "y": Number(consumePerHead.toFixed(4)) // Aumentar precisi├│n para valores peque├▒os
            }
          })
          return array
      } catch (err) {
        return [];
      }
    },
    consumePerHeadLabels() {
      try {
        return this.siloConsumePerHeadDataset.map(item => {
          const date = new Date(item.x);
          return format(date, 'dd/MM');
        });
      } catch (err) {
        return [];
      }
    },
    consumePerHeadValues() {
      try {
        return this.siloConsumePerHeadDataset.map(item => item.y);
      } catch (err) {
        return [];
      }
    },
    accumulatedConsumeLabels() {
      try {
        return this.siloUnloadDatasetAccumulated.map(item => {
          const date = new Date(item.x);
          return format(date, 'dd/MM');
        });
      } catch (err) {
        return [];
      }
    },
    accumulatedConsumeValues() {
      try {
        return this.siloUnloadDatasetAccumulated.map(item => item.y);
      } catch (err) {
        return [];
      }
    },
    consolidatedConsumeLabels() {
      try {
        return this.siloUnloadDataset.map(item => {
          const date = new Date(item.x);
          return format(date, 'dd/MM');
        });
      } catch (err) {
        return [];
      }
    },
    consolidatedConsumeValues() {
      try {
        return this.siloUnloadDataset.map(item => item.y);
      } catch (err) {
        return [];
      }
    },
    consolidatedConsumeEstimated() {
      try {
        return this.sensorsData.data
          .filter(item => {
            const itemDate = this.formatToYYYYMMDD(item.date);
            return itemDate >= this.startDateFilter && itemDate <= this.endDateFilter;
          })
          .map(item => !!item.estimated);
      } catch (err) {
        return [];
      }
    },
    unloadData() {
      const setting = [
        {
          label: "Consumo Di├írio",
          pointRadius: 3,
          data: this.siloUnloadDataset,
          type: "bar",
          fill: false,
          borderColor: "rgba(137, 194, 91, 1)",
          backgroundColor: "rgba(137, 194, 91, 1)",
          borderWidth: 2,
          yAxisID: "Consume",
          barPercentage: 0.75,
        },
      ];
      return setting;
    },
    unloadAccData() {
      const setting = [
        {
          label: "Consumo Acumulado",
          pointRadius: 3,
          data: this.siloUnloadDatasetAccumulated,
          type: "line",
          fill: true,
          borderColor: "rgba(91, 138, 52, 0.9)",
          backgroundColor: "rgba(91, 138, 52, 0.9)",
          borderWidth: 2,
          yAxisID: "AccumulatedConsume",
        },
      ];
      return setting;
    },
    barn() {
      return this.$store.getters.getBarnTarget;
    },
    batch() {
      if (this.$store.getters.getBatchTarget == null) {
        return this.barn.batch
      }
      return this.$store.getters.getBatchTarget
    },
    barnName() {
      if (this.barn == null) {
        return ""
      }
      return `${this.barn.name}`
    },
    batchName() {
      if (this.batch == null) return ''
      return `- LOTE ${this.batch.pk}`
    },
    farmName() {
      if (this.barn) {
          return this.$store.getters.getAllBarns.find((obj)=> {
          return obj.barn.find((barn)=>barn.pk == this.barn.pk)
        }).farm.name
      }
      return ''
    },
    last_date() {
      if (this.batch.date_departure != null) return this.batch.date_departure;
      let today = new Date();
      today.setDate(today.getDate());
      return today;
    },
    userLevel() {
      return this.$store.getters.getUserLevel
    },
    errorMessage() {
      return this.$store.getters.getErrorMessage
    },
    formatDateRange() {
      const startDate = format(parseISO(this.batch.date_accomodation), 'dd/MM/yyyy', { locale: ptBR });
      const endDate = this.batch.date_departure
        ? format(parseISO(this.batch.date_departure), 'dd/MM/yyyy', { locale: ptBR })
        : 'Lote em Andamento';

      return `${startDate} - ${endDate}`;
    },
    chartStartDate() {
      return this.startDateFilter;
    },
    chartEndDate() {
      return this.endDateFilter;
    },
    lossesBatch() {
      const rawLosses = this.$store.getters.getLossesBatch || [];
      const batchPk = this.batch && this.batch.pk ? this.batch.pk : null;

      // Filter to current batch (store keeps a global list, so it may contain other batches)
      const filtered = batchPk == null ? rawLosses : rawLosses.filter(l => l.batch == batchPk);

      // Deduplicate by pk (avoid repeated fetches pushing the same losses multiple times)
      const byPk = new Map();
      filtered.forEach(loss => {
        if (loss && loss.pk != null) byPk.set(loss.pk, loss);
      });

      const losses = Array.from(byPk.values())
        .slice()
        .sort((a, b) => new Date(a.death_datetime) - new Date(b.death_datetime));

      return losses;
    },
  },
  watch: {
    seekNewRange: {
      handler: async function() {
          this.forceRerenderUnload();
          this.forceRerenderConsumePerHead();
          this.forceRerenderAccumulated();
      }
    },
    batch: {
      handler: function(newBatch) {
        // Si el batch se vuelve nulo y estamos en la pesta├▒a perHead, cambiar a consolidated
        if ((!newBatch || newBatch === null || (newBatch.final_count <= 0 && newBatch.initial_count <= 0)) && this.activeTab === 'perHead') {
          this.activeTab = 'consolidated';
        }
      },
      immediate: true
    }
  },
  async created() {
    this.initializeDateFilters();

    let today = new Date();
    const today_date = format(today, 'yyyy-MM-dd');
    const barn = this.barn.pk;

    const accommodation = this.formatToYYYYMMDD(this.batch.date_accomodation);

    const departure = this.batch.date_departure != null ? this.formatToYYYYMMDD(this.batch.date_departure) : today_date;

    try {
      await this.$store.dispatch("fetchFeedConsolidatedData", {
        barn,
        accommodation,
        departure,
      });

      // Fetch losses data to calculate daily animal count
      if (this.batch && this.batch.pk) {
        await this.$store.dispatch('fecthLossesByBatch', {batch: this.batch.pk, url: null});
      }
    } catch(err) {
      this.fetchFailed = true;
    }

    this.loading = false;
  },
};
</script>

<style scoped>
.consolidated-data {
  width: 100%;
}

.consolidated-panel {
  background: #ffffff;
  padding: 12px 16px 16px;
  border-radius: 8px;
  margin-top: 8px;
  position: relative;
}

.chart-without-data--panel {
  position: relative;
  min-height: 180px;
  height: auto;
  margin-bottom: 0;
}

.chart-toolbar {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 12px 16px;
  margin-bottom: 12px;
  padding: 12px 16px;
  background: linear-gradient(180deg, #f8faf9 0%, #f1f4f2 100%);
  border: 1px solid #e2e8e4;
  border-radius: 10px;
}

.toolbar-group {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}

.toolbar-group--filters {
  flex: 1 1 520px;
  justify-content: center;
}

.toolbar-group--actions {
  flex: 0 0 auto;
  justify-content: center;
}

.toolbar-label {
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #1b4238;
  white-space: nowrap;
}

.toolbar-divider {
  width: 1px;
  height: 36px;
  background: #cfd8d3;
  flex-shrink: 0;
}

.toolbar-actions {
  display: flex;
  gap: 10px;
  flex-shrink: 0;
}

.chart-without-data {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  color: #333;
  background: rgba(248, 249, 250, 0.95);
  border-radius: 8px;
  border: 1px solid #e9ecef;
}

.chart-without-data h1 {
  margin: 5px 0;
  font-size: 1.5rem;
  font-weight: 600;
  color: #6c757d;
  text-align: center;
}

.chart-active {
  margin-left: 3%;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  top: 0;
  left: 0;
  height: 24px;
  margin-bottom: 12px;
}

.chart-active .chart-title {
  display: flex;
  align-items: center;
}

.chart-active .chart-title p {
  margin: 0;
}

.warning {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50vh;
}

.warning .text {
  background: #78b843;
  border-radius: 10px;
  color: #fff;
  padding: 20px;
  font-size: 30px;
}

.warning .text h1 {
  display: flex;
  justify-content: center;
}

.warning .text p {
  display: flex;
  justify-content: center;
  margin: 0;
}

.error-message {
  font-size: 2rem;
  color: #dc3545;
  font-weight: 600;
}

.mobile-info {
  display: none;
}

.situacao-atual-feed-bom {
  background: #78b843 !important;
}

.situacao-atual-feed-medio {
  background: #e2bf65 !important;
}

.situacao-atual-feed-ruim {
  background: #a94949 !important;
}

strong {
  font-weight: 700;
}

@media screen and (max-width: 991px) {
  .silo {
    display: none;
  }

  .mobile-info {
    display: grid;
  }

  .chart-header {
    gap: 20px;
  }

  .date-filter-buttons {
    flex-wrap: wrap;
    justify-content: center;
  }

  .filter-btn {
    flex: 1;
    min-width: 120px;
    max-width: 150px;
  }

  .tabs-header {
    flex-wrap: wrap;
  }

  .tab-button {
    flex: 1;
    min-width: 120px;
  }
}

@media screen and (max-width: 600px) {
  .chart-header {
    flex-direction: column;
    gap: 15px;
  }

  .header-section {
    flex-direction: column;
    gap: 15px;
    align-items: stretch;
  }

  .date-filter-buttons {
    flex-direction: column;
  }

  .filter-btn {
    width: 100%;
    max-width: none;
  }

  .tabs-header {
    flex-direction: column;
  }

  .tab-button {
    width: 100%;
    border-radius: 0;
  }

  .tab-button:first-child {
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
  }

  .tab-button:last-child {
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
  }
}

@media screen and (max-width: 768px) {
  .consolidated-panel {
    padding: 10px 12px 12px;
    margin-top: 4px;
  }

  .chart-toolbar {
    flex-direction: column;
    align-items: stretch;
    padding: 10px 12px;
  }

  .toolbar-divider {
    width: 100%;
    height: 1px;
  }

  .toolbar-group--filters,
  .toolbar-group--actions {
    flex: 1 1 auto;
    justify-content: center;
  }

  .toolbar-actions {
    width: 100%;
    justify-content: center;
  }

  .warning {
    height: 250px;
  }

  .warning h1 {
    font-size: 30px;
  }

  .warning p {
    font-size: 20px;
  }

  .chart-header {
    flex-direction: column;
    gap: 20px;
  }

  .header-section {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 15px;
  }

  .export-dropdown {
    position: relative;
  }

  .export-btn {
    padding: 10px 15px;
    min-width: auto;
    font-size: 14px;
  }

  .export-btn span {
    display: inline;
  }

  .export-btn i:last-child {
    display: inline;
  }

  .dropdown-content {
    width: 140px;
    right: 0;
    left: auto;
  }

  .dropdown-content a {
    padding: 12px 16px;
    justify-content: flex-start;
  }

  .dropdown-content a span {
    display: inline;
  }

  .dropdown-content i {
    font-size: 1rem;
  }

  .button-food {
    min-width: 120px;
    padding: 10px 15px;
    font-size: 14px;
  }

  .date-filter-buttons {
    flex-direction: column;
    gap: 15px;
    width: 100%;
  }

  .filter-btn {
    padding: 12px 20px;
    font-size: 14px;
    min-width: 100%;
    width: 100%;
  }

  .custom-date-filter {
    flex-direction: column;
    gap: 15px;
    width: 100%;
  }

  .date-input {
    width: 100%;
    padding: 12px 15px;
    font-size: 14px;
    border: 2px solid #1b4238;
    border-radius: 6px;
  }

  .custom-filter-btn {
    padding: 12px 20px;
    font-size: 14px;
    min-width: 100%;
    width: 100%;
  }

  .tabs-header {
    flex-direction: column;
    border-bottom: none;
    gap: 0;
  }

  .tab-button {
    padding: 15px 20px;
    font-size: 14px;
    border-bottom: 2px solid #e0e0e0;
    border-radius: 0;
    text-align: center;
  }

  .tab-button:first-child {
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
  }

  .tab-button:last-child {
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
  }

  .tab-button.active {
    background-color: #1b4238;
    color: white;
    border-bottom-color: #1b4238;
  }

  .chart-card {
    padding: 15px;
    margin: 0;
  }

  .tab-content {
    min-height: 200px;
  }

  .chart-container {
    height: 250px;
  }
  .chart-without-data h1 {
    font-size: 1.2rem;
    margin: 3px 0;
  }

  .error-message {
    font-size: 1.5rem;
  }
}

@media screen and (max-width: 480px) {
  .warning h1 {
    font-size: 25px;
  }

  .warning p {
    font-size: 15px;
  }

  /* Extra small screens improvements */
  .chart-header {
    gap: 15px;
  }

  .header-section {
    flex-direction: column;
    gap: 15px;
    align-items: stretch;
  }

  .button-food {
    width: 100%;
    text-align: center;
  }

  .export-btn {
    width: 100%;
    justify-content: center;
  }

  .tab-button {
    padding: 12px 15px;
    font-size: 13px;
  }

  .filter-btn {
    padding: 10px 15px;
    font-size: 13px;
  }

  .date-input {
    padding: 10px 12px;
    font-size: 13px;
  }

  .custom-filter-btn {
    padding: 10px 15px;
    font-size: 13px;
  }

  .chart-container {
    height: 200px;
  }

  .chart-without-data h1 {
    font-size: 1rem;
  }

  .error-message {
    font-size: 1.2rem;
  }
}

@media screen and (max-width: 360px) {
  .warning {
    height: 200px;
  }

  .warning h1 {
    font-size: 20px;
  }

  .warning p {
    font-size: 10px;
  }

  /* Very small screens optimizations */
  .chart-card {
    padding: 10px;
  }

  .tab-button {
    padding: 10px 12px;
    font-size: 12px;
  }

  .filter-btn {
    padding: 8px 12px;
    font-size: 12px;
  }

  .date-input {
    padding: 8px 10px;
    font-size: 12px;
  }

  .custom-filter-btn {
    padding: 8px 12px;
    font-size: 12px;
  }

  .button-food {
    padding: 8px 12px;
    font-size: 12px;
  }

  .export-btn {
    padding: 8px 12px;
    font-size: 12px;
  }

  .chart-container {
    height: 180px;
  }

  .chart-without-data h1 {
    font-size: 0.9rem;
  }

  .error-message {
    font-size: 1rem;
  }
}


.chart-title-main {
  text-align: center;
  margin: 0 0 12px;
}

.chart-title-main h2 {
  margin: 0;
  font-size: 16px;
  font-weight: bold;
}

.chart-subtitle {
  margin: 5px 0 0;
  color: #666;
  font-size: 12px;
  font-style: italic;
}

.chart-title {
  text-align: center;
  margin: 0 auto;
}

.header-buttons {
  display: flex;
  align-items: center;
  gap: 12px;
  justify-content: flex-end;
}

.export-dropdown {
  position: relative;
  display: flex;
  justify-content: center;
  gap: 10px;
}

/* O pai (SmartfeedPage3) aplica .is-refreshing com pointer-events: none no card;
   estes botões não alteram o intervalo de dados e devem continuar clicáveis. */
.is-refreshing .export-dropdown {
  pointer-events: auto;
}

.export-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 15px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 500;
  transition: all 0.2s ease;
  background-color: #1b4238;
  color: white;
  min-width: 50px;
  justify-content: center;
}

.export-btn:hover {
  background-color: #218838;
}

.button-food {
  background-color: #1b4238;
  color: #fff;
  padding: 8px 12px;
  border-radius: 4px;
  border: none;
  cursor: pointer;
  font-weight: 500;
  transition: all 0.2s ease;
  min-width: 120px;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.3);
}

.button-food:hover {
  background-color: #1e7e34;
  box-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);
}

.dropdown-content a {
  color: #333;
  padding: 12px 16px;
  text-decoration: none;
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.dropdown-content a:hover {
  background-color: #f8f9fa;
}

.dropdown-content i {
  width: 16px;
  text-align: center;
}

.dropdown-content a:first-child i {
  color: #dc3545;
}

.dropdown-content a:last-child i {
  color: #28a745;
}

.dropdown-content {
  position: absolute;
  top: 100%;
  right: 0;
  background-color: #fff;
  width: 140px;
  box-shadow: 0 8px 16px rgba(0,0,0,0.1);
  z-index: 1;
  border-radius: 4px;
  overflow: hidden;
  margin-top: 4px;
}

/* New styles for tabs */
.chart-card {
  background-color: #fff;
  border-radius: 8px;
  padding: 20px;
  padding-top: 0px;
}

.tabs-container {
  width: 100%;
}

.tabs-header {
  display: flex;
  border-bottom: 2px solid #e0e0e0;
  margin-bottom: 20px;
}

.tab-button {
  flex: 1;
  padding: 12px 20px;
  border: none;
  background-color: transparent;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  color: #666;
  transition: all 0.3s ease;
  border-bottom: 3px solid transparent;
  position: relative;
}

.tab-button:hover {
  background-color: #f8f9fa;
  color: #333;
}

.tab-button.active {
  color: #28a745;
  border-bottom-color: #28a745;
  background-color: #f8f9fa;
}

.tab-content {
  min-height: 250px;
  position: relative;
}

.tab-panel {
  width: 100%;
}

.chart-container {
  width: 100%;
  height: 300px;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}

.chart-container canvas {
  max-width: 100% !important;
  height: auto !important;
}

.chart-header {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.date-filter-buttons {
  display: flex;
  gap: 8px;
  justify-content: center;
  flex-wrap: wrap;
  margin-top: 0;
  align-items: center;
}

.filter-btn {
  padding: 8px 16px;
  border: 2px solid #1b4238;
  border-radius: 6px;
  background-color: #fff;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  color: #1b4238;
  transition: all 0.2s ease;
  min-width: 100px;
  text-align: center;
}

.filter-btn:hover {
  background-color: #1b4238;
  color: white;
}

.filter-btn.active {
  background-color: #1b4238;
  color: white;
  border-color: #1b4238;
}

.filter-btn:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.filter-btn:disabled:hover {
  background-color: #fff;
  color: #1b4238;
}

.custom-date-filter {
  display: flex;
  gap: 5px;
  align-items: center;
}

.date-input {
  padding: 8px 12px;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 13px;
  width: 120px;
  box-sizing: border-box;
}

.custom-filter-btn {
  padding: 8px 16px;
  border: 2px solid #1b4238;
  border-radius: 6px;
  background-color: #fff;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  color: #1b4238;
  transition: all 0.2s ease;
  min-width: 100px;
  text-align: center;
}

.custom-filter-btn:hover {
  background-color: #1b4238;
  color: white;
}

.custom-filter-btn.active {
  background-color: #1b4238;
  color: white;
  border-color: #1b4238;
}
</style>
